import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,2.25 c -5.3851246,0 -9.75,4.3648754 -9.75,9.75 0,5.384095 4.3648154,9.75 9.75,9.75 5.385195,0 9.75,-4.365905 9.75,-9.75 0,-5.3851246 -4.364905,-9.75 -9.75,-9.75 z m 3.462891,6.6914063 c 0.191924,0 0.382847,0.0723 0.529297,0.21875 0.292899,0.2928897 0.292899,0.7696402 0,1.0624997 L 11.375,14.839844 c -0.2928,0.292899 -0.767647,0.292799 -1.060547,0 L 8.0058594,12.53125 c -0.2929597,-0.2928 -0.2947829,-0.767647 -0.00195,-1.060547 0.2928197,-0.293 0.7675871,-0.2928 1.0605468,0 l 1.7812498,1.777344 4.085938,-4.0878907 c 0.146449,-0.1464499 0.339325,-0.21875 0.53125,-0.21875 z"
	})]
});
export default SvgCheckCircleFill;
